export default __webpack_public_path__ + "static/media/logo.f910521d.svg";